module.exports = __webpack_public_path__ + "static/WEDDING E&M-245-e3ef2ab06b1f0026a8fb86e2f2aa555d.jpg";